module.exports = __webpack_public_path__ + "img/terminal-0.873bfdb5.png";